import { fetcher } from "helpers/fetcher";

import { TGetEmployeeAccessReq, TGetEmployeeAccessRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEmployeeAccess = async (params?: TGetEmployeeAccessReq) => {
  return await fetcher<TGetEmployeeAccessRes, any>(
    ENDPOINT.BU.GET_EMPLOYEE_ACCESS,
    {
      params: params,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_EMPLOYEE_ACCESS.version,
        [API_HEADER.USER_ID]: params?.userId,
        [API_HEADER.BU_ID]: params?.buId,
      },
    }
  );
};

export const queryGetEmployeeAccess = async (
  params?: TGetEmployeeAccessReq
) => {
  return (await getEmployeeAccess(params)).data;
};

queryGetEmployeeAccess._key = (params?: TGetEmployeeAccessReq) => [
  ENDPOINT.BU.GET_EMPLOYEE_ACCESS.url,
  params,
];
